export default "__VITE_ASSET__CkBFenwF__"